<form [formGroup]="form()">
    <div class="grid gap-4 mb-4" [class.grid-cols-1]="isCompact()" [class.grid-cols-3]="!isCompact()">
        <spike-field-text 
            formControlName="isin" 
            label="Isin" 
            placeholder="Es: US0378331005">
        </spike-field-text>

        <spike-field-text 
            formControlName="shortDescription" 
            label="Titolo" 
            placeholder="Es: Apple Inc.'s">
        </spike-field-text>

        <spike-field-text 
            formControlName="isinType" 
            label="Tipo posizione" 
            placeholder="Es: Fondo, ETC, ETF">
        </spike-field-text>
    </div>
</form>